import React from "react";
import {useState} from 'react';

function NavSticky(){
    const [activeNav,setActiveNav] = useState('#');
    return (
    <nav class="stickynav">
        <a href="#" className={activeNav === '#' ? 'active' : ''}><i class='bx bx-home-circle'></i></a>
        <a href="#about" onClick={()=> setActiveNav('#about')} className={activeNav === '#about'? 'active' : ''}><i class='bx bxs-user'></i></a>
        <a href="#skills" onClick={()=> setActiveNav('#skills')} className={activeNav === '#skills'? 'active' : ''}><i class='bx bxs-star' ></i></a>
        <a href="#experience" onClick={()=> setActiveNav('#experience')} className={activeNav === '#experience'? 'active' : ''}><i class='bx bxs-book'></i></a>
        <a href="#contact" onClick={()=> setActiveNav('#contact')} className={activeNav === '#contact'? 'active' : ''}><i class='bx bxs-contact'></i></a>
    </nav>
);}

export default NavSticky;